import { Injectable, Pipe, PipeTransform } from '@angular/core';

/*
  Generated class for the Weight pipe.

  See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
  Angular 2 Pipes.
*/
@Pipe({
    name: 'tdate'
})
@Injectable()
export class TenderCutsDatePipe implements PipeTransform {
    DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday",
        "Saturday"];

    transform(value, args) {

        const today = new Date();
        const current = new Date(value);
        let cDate;

        if (current.getDate() < 10) {
            cDate = "0" + current.getDate();
        } else {
            cDate = current.getDate();
        }
        const month = "" + (current.getMonth() + 1);

        const diff = current.getDay() - today.getDay();

        let representation = "";
        if (diff === 0) {
            representation += "Today - ";
        }
        if (diff === 1) {
            representation += "Tomorrow - ";
        }

        representation += `${this.DAYS[current.getDay()]} `;

        // [27/03]
        representation += "[";
        representation += `${cDate}/`;
        representation += `0${month}`.slice(-2);
        representation += "]";

        return representation;
    }
}
